<template>
  <div>
    <base-header type="gradient-info" class="pb-1 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col">
          <h1 class="text-white pt-3 px-3">หน้าจัดการใบนำส่งพัสดุ</h1>
          <p class="text-white pb-3 px-3">
            แสดงข้อมูลพัสดุทั้งหมดของสาขาที่ยังไม่ได้สร้างใบนำส่งพัสดุ โดยสามารถเลือกวันที่สามารถมาแสดงผลได้</p>
        </div>
        <div class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
          <template v-if="selected.length > 0">
            <button 
              class="btn btn-xl btn-warning" 
              :disabled="selected.length < 1" 
              @click="showComfirmModal()"
            >
              สร้างใบนำส่งพัสดุ
            </button>
          </template>
          <template v-else-if="createTypeBy === TYPE.SCAN">
            <button 
              class="btn btn-xl btn-warning"
              @click="onChangeCreateType()"
            >
              เสร็จสิ้น
            </button>
          </template>
          <template v-else>
            <button 
              class="btn btn-xl btn-warning"
              @click="onChangeCreateType(TYPE.SCAN)"
            >
              สแกนสร้างใบนำส่งพัสดุ
            </button>
          </template>
        </div>
        <template v-if="createTypeBy === TYPE.SCAN">
          <div class="col-12 mb-1">
            <ScanSOP @onUpdate="onScanSuccess" />
          </div>
        </template>
        <div class="col-12">
          <BacklogParcel :total_LZDS="total_LZDS" :filters="filters"/>
        </div>
      </div>
    </base-header>
    
    <div class="container-fluid mt-1 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row">
                <div class="col-12 col-md-12 col-lg-12">
                    <div class="row">
                        <div class="col-md-12 col-lg-4">
                            <b-form-group label="ค้นหาวันที่ (วันเริ่มต้น - วันสุดท้าย)" class="mb-0">
                                <date-range-picker
                                    class="w-100"
                                    :opens="'center'"
                                    @start-selection="logEvent('startSelection', $event)"
                                    @finish-selection="logEvent('finishSelection', $event)"
                                    :min-date="minDate"
                                    :max-date="maxDate"
                                    :singleDatePicker="false"
                                    :appendToBody="true"
                                    :ranges="false"
                                    :closeOnEsc="false"
                                    :autoApply="true"
                                    :locale-data="{ format: 'dd/mm/yyyy' }"
                                    v-model="filters">
                                </date-range-picker>
                            </b-form-group>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <b-form-group
                                label="ค้นหาสถานะพัสดุ"
                                class="mb-0"
                            >
                                <select class="form-control" @click.stop.prevent v-model="filters.status_parcel">
                                    <option 
                                        :value="option.value" 
                                        v-for="option in optionsStatus" 
                                        :key="option.value">
                                        {{ option.text }}
                                    </option>
                                </select>
                            </b-form-group>
                        </div>
                        <div class="col-md-6 col-lg-4 d-flex align-items-end">
                            <b-form-group
                              id="input-group-1"
                              label="ค้นหาขนส่ง"
                              label-for="input-1"
                              class="mb-0" :class="{'col-10': filters.courier_code !='LZDS', 'col-12': filters.courier_code == 'LZDS'}">
                              <select class="form-control" @click.stop.prevent v-model="filters.courier_code" @change="onCourierChange()">
                                <option value="">ทั้งหมด</option>
                                <option :value="option.courier_code" v-for="option in options" :key="option.courier_code">{{ option.name }}</option>
                              </select>
                            </b-form-group>
                            <button class="btn-block btn btn-info btn-sm-res col-2"
                              v-if="filters.courier_code != 'LZDS'"
                              v-on:click="getDelivery()">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                        <div class="col-md-6 col-lg-4 p-0 pt-2 d-flex align-items-end" v-if="filters.courier_code == 'LZDS'">
                            <b-form-group
                              id="input-group-1"
                              label="ขนส่งที่เข้ารับ"
                              label-for="input-1"
                              class="mb-0 col-10">
                              <select class="form-control" @click.stop.prevent v-model="filters.courier_tracking_code_prefix">
                                <option value="">ทั้งหมด</option>
                                <option value="KERDO">Kerry Express (KERDO)</option>
                                <option value="LEXDO">Lazada Express (LEXDO)</option>
                                <option value="TH">Flash Express (TH)</option>
                                <option value="510">J&T Express (510)</option>
                              </select>
                            </b-form-group>
                            <button class="btn-block btn btn-info btn-sm-res col-2" v-if="filters.courier_code == 'LZDS'" v-on:click="getDelivery()">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                        <div class="col-md-6 col-lg-4 pt-2">
                          <b-form-group
                            id="input-group-1"
                            label="ค้นหาข้อมูล"
                            label-for="input-1"
                            class="mb-0">
                              <b-form-input v-model="filter" id="input-1" type="text" required placeholder></b-form-input>
                          </b-form-group>
                        </div>
                    </div>
                    <hr class="d-md-none d-lg-none" />
                </div>
              </div>
            </div>
            <div id="tablePrint">
              <b-table
                ref="reportDelivery"
                show-empty
                responsive
                :selectable="createTypeBy === TYPE.DEFAULT"
                :items="itemFilter"
                :fields="fields"
                :busy="busy"
                @row-selected="onRowSelected"
                class="scroll-bar-pop"
                foot-clone
              >
                <div slot="table-busy" class="text-center">
                  <BlockUI>
                    <div class="loader"></div>
                  </BlockUI>
                </div>
                <template slot="HEAD_selected" v-if="createTypeBy === TYPE.DEFAULT">
                  <b-form-checkbox v-model="checkSelect" @change="selectAllRows" class="text-center"></b-form-checkbox>
                </template>
                <template 
                  slot="selected" 
                  slot-scope="{ rowSelected }"
                  v-if="createTypeBy === TYPE.DEFAULT"
                >
                    <template v-if="rowSelected">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" autocomplete="off" class="custom-control-input" value="true" checked>
                        <label class="custom-control-label"></label>
                      </div>
                    </template>
                    <template v-else>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" autocomplete="off" class="custom-control-input" value="false">
                        <label class="custom-control-label"></label>
                      </div>
                    </template>
                </template>
                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                <template slot="created_at" slot-scope="row">{{ row.item.created_at.date | dateFormat }}</template>
                <template slot="status_parcel" slot-scope="row">
                    <b-badge :variant="statusInfo(row.item, {status: 'status_parcel'}).color +' report'" 
                      v-b-tooltip :title="statusInfo(row.item).tooltip">
                        {{statusInfo(row.item, {status: 'status_parcel'}).status}}
                    </b-badge>
                </template>
                <template slot="dimension" slot-scope="row"> 
                  {{ ( Number(row.item.dimension.width)+Number(row.item.dimension.length)+Number(row.item.dimension.height) ) > 3 ? row.item.dimension.width+'x'+row.item.dimension.length+'x'+row.item.dimension.height : '-'}}
                </template>
                <template slot="weight" slot-scope="row">
                  {{ (row.item.weight) ? ( ( $THEME.unitKG ) ? (row.item.weight / 1000) : row.item.weight ) : '-'}}
                </template>
            
                <template slot="FOOT_selected">&nbsp;</template>
                <template slot="FOOT_index">&nbsp;</template>
                <template slot="FOOT_created_at"> &nbsp;</template>
                <template slot="FOOT_postcode"> &nbsp;</template>
                <template slot="FOOT_name"> &nbsp;</template>
                <template slot="FOOT_province"> &nbsp;</template>
                <template slot="FOOT_receipt_no"> &nbsp;</template>
                <template slot="FOOT_tel"> &nbsp;</template>
                <template slot="FOOT_barcode"> &nbsp; </template>
                <template slot="FOOT_courier">&nbsp; </template>
                <template slot="FOOT_status_parcel"> &nbsp;</template>
                <template slot="FOOT_weight"> &nbsp;</template>
                <template slot="FOOT_dimension"> &nbsp;</template>
                <template slot="FOOT_price"> &nbsp;</template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import validatePop from "../plugins/validatePop.js"
import BacklogParcel from "@/components/custom/Backlog/Parcel/CardBacklog"
import ScanSOP from "@/components/custom/Backlog/Parcel/ScanSOP"
import moment from "moment";
import { dateLimitRanges } from "@/plugins/datePicker.js"
import { statusInfo } from "@/plugins/statusCourier.js"
const API_URL = process.env.VUE_APP_API;
export default {
  components:{
    BacklogParcel,
    ScanSOP
  },
  data() {
    return {
      TYPE:{
        SCAN: "SCAN",
        DEFAULT: "DEFAULT",
      },
      unLoad: false,
      deliveryId: null,
      createTypeBy: "DEFAULT",
      itemProduct: [],
      // filters.courier_code: '',
      // filters.courier_tracking_code_prefix: '',
      busy: true,
      userLogin: "",
      filter: '',
      minDate: null,
      maxDate: moment().format("YYYY-MM-DD"),
      filters: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        courier_code: '',
        courier_tracking_code_prefix: '',
        status_parcel: 'BOOKING'
      },
      total_LZDS: {},
      selected: [],
      checkSelect: false,
      // filters.status_parcel: 'BOOKING',
      statusInfo: statusInfo,
    };
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
  },
  beforeRouteLeave (to, from, next) {
    if( this.unLoad ){
      const check = confirm("ท่านแน่ใจว่าต้องการออกจากหน้านี้")
      next(check)
      return true  
    }
    next()
  },
  created(){
    this.userLogin = JSON.parse(localStorage.getItem("user"))
    // window.addEventListener('beforeunload', this.boforeUnload)
  },
  mounted() {
    this.getDelivery();  
    console.log('lazada filters: ', this.filters)
  },
  methods: {
    logEvent( event , date ){
        const { minDate , maxDate } =  dateLimitRanges(event, date);
        this.minDate = minDate
        this.maxDate = maxDate
    },
    onScanSuccess(listOrderDetailIds){
      const indexOfItem = this.itemProduct.findIndex( item => {
        return item.id === listOrderDetailIds[0]
      })
      if( indexOfItem > -1 ){
        this.unLoad = true
        this.itemProduct.splice(indexOfItem, 1)
      }
    },
    onChangeCreateType(type = this.TYPE.DEFAULT){
      this.selected = []
      this.createTypeBy = type
    },
    boforeUnload(event) {
      if( this.unLoad ){
        event.returnValue = 'You have unsaved changes!'
      }
    },
    getDelivery() {
      this.busy = true;
      this.$http
        .post(
          API_URL + "/shop/delivery",
          {
            start: moment(this.filters.startDate).format("YYYY-MM-DD"),
            end: moment(this.filters.endDate).format("YYYY-MM-DD"),
            type: "ship",
            status_parcel: this.filters.status_parcel,
            courier_code: this.filters.courier_code,
            courier_tracking_code_prefix: this.filters.courier_code=='LZDS'?this.filters.courier_tracking_code_prefix:''
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.busy = false;
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.checkSelect = false
          this.itemProduct = res.data.data.data
          const LZDS_DATA = res.data.data.total_LZDS
          this.total_LZDS = [
              {
                courier: 'Lazada Express',
                total: LZDS_DATA.LEXDO.TOTAL,
                wait: LZDS_DATA.LEXDO.WAIT,
                booking: LZDS_DATA.LEXDO.BOOKING,
                complete: LZDS_DATA.LEXDO.COMPLETE,
                cancel: LZDS_DATA.LEXDO.CANCEL,
                invalid: LZDS_DATA.LEXDO.INVALID
              },
              {
                courier: 'Kerry Express',
                total: LZDS_DATA.KERDO.TOTAL,
                wait: LZDS_DATA.KERDO.WAIT,
                booking: LZDS_DATA.KERDO.BOOKING,
                complete: LZDS_DATA.KERDO.COMPLETE,
                cancel: LZDS_DATA.KERDO.CANCEL,
                invalid: LZDS_DATA.KERDO.INVALID
              },
              {
                courier: 'J&T Express',
                total: LZDS_DATA['510'].TOTAL,
                wait: LZDS_DATA['510'].WAIT,
                booking: LZDS_DATA['510'].BOOKING,
                complete: LZDS_DATA['510'].COMPLETE,
                cancel: LZDS_DATA['510'].CANCEL,
                invalid: LZDS_DATA['510'].INVALID
              },
          ]
          if (this.$THEME.name == 'shippop' && LZDS_DATA && LZDS_DATA['TH'] && LZDS_DATA['TH'].TOTAL > 0) {
            this.total_LZDS.push({
              courier: 'Flash Express',
              total: LZDS_DATA['TH'].TOTAL,
              wait: LZDS_DATA['TH'].WAIT,
              booking: LZDS_DATA['TH'].BOOKING,
              complete: LZDS_DATA['TH'].COMPLETE,
              cancel: LZDS_DATA['TH'].CANCEL,
              invalid: LZDS_DATA['TH'].INVALID
            });
          }
          this.total_LZDS.push(
              {
                courier: 'รวม',
                total: LZDS_DATA.total_prefix.TOTAL,
                wait: LZDS_DATA.total_prefix.WAIT,
                booking: LZDS_DATA.total_prefix.BOOKING,
                complete: LZDS_DATA.total_prefix.COMPLETE,
                cancel: LZDS_DATA.total_prefix.CANCEL,
                invalid: LZDS_DATA.total_prefix.INVALID
              });
          this.itemProduct.forEach((data, i)=>{
            this.itemProduct[i].date_created = data.created_at.date
          });
          this.busy = false
        });
    },
    createDocumentDelivery(){
      this.busy = true
      this.$http
        .post(
          API_URL + "/shop/create/delivery",
          {
            delivery: this.selected,
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.busy = false
              this.showErrorModal( checkError.msg )
              return false
            }
            this.busy = false
            this.printDelivery(res.data.data.deliveryHTML);
            this.showSuccessModal("สร้างใบนำส่งพัสดุเสร็จเรียบร้อยค่ะ ใบนำส่งพัสดุเลขที่ " + res.data.data.delivery_no);
            this.getDelivery();
        })
        .catch(error => {
          this.showErrorModal(error)
        });
    },
    onCourierChange() {
      console.log('this.filters', this.filters)
      if (this.filters.courier_code != 'LZDS') {
        this.filters.courier_tracking_code_prefix = ''
      }
    },
    printDelivery(html) {
      const win = window.open("");
      win.document.write(html);
      setTimeout(() => {
        win.document.close();
        win.focus();
        win.print();
        win.close();
      }, 100);
    },
    isDetail() {
      return !!this.$route.params.Id;
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      if(this.itemFilter.length < 1){
        return false
      }
      this.checkSelect = !this.checkSelect
      if(this.checkSelect){
        this.$refs.reportDelivery.selectAllRows()
      }else{
        this.$refs.reportDelivery.clearSelected()
      }
    },
    showComfirmModal() {
      this.$bvModal
        .msgBoxConfirm(`คุณต้องการจะสร้างใบนำส่งพัสดุ รายการที่เลือกจะไม่สามารถแก้ไขหรือนำมาสร้างใบนำส่งพัสดุใหม่ได้`, {
          title: "กรุณายืนยัน",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          contentClass: "modal-confirm",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.createDocumentDelivery();
          }
        });
    },
    showSuccessModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
  },
  computed: {
    fields(){ 
     let fields = [
        { key: "selected", label: "เลือกรายการ", class: "text-center" },
        { key: "index", label: "ลำดับ", sortable: true },
        { key: "created_at", label: "วันที่สร้างรายการ", sortable: true },
        { key: "receipt_no", label: "เลขที่ใบเสร็จ", sortable: true },
        { key: "province", label: "จังหวัดผู้รับ", sortable: true, class: "text-center"} ,
        { key: "postcode", label: "รหัสไปรษณีย์ผู้รับ", sortable: true, class: "text-center" },
        { key: "name", label: "ชื่อผู้รับ", sortable: true, class: "text-center" },
        { key: "barcode", label: "หมายเลขติดตามพัสดุ", sortable: true, class: "text-center" },
        { key: "courier", label: "ชื่อขนส่ง", sortable: true },
        { key: "status_parcel", label: "สถานะพัสดุ", sortable: true },
        { key: "weight", label: ( this.$THEME.unitKG ) ? 'น้ำหนัก (กิโลกรัม)':'น้ำหนัก (กรัม)', sortable: true },
        { key: "dimension", label: "ขนาดพัสดุ (ซม.)", sortable: true },
        { key: "price", label: "ราคาขาย", sortable: true },
      ]
      if( this.createTypeBy !== this.TYPE.DEFAULT ){
        fields = fields.filter( item => item.key !== 'selected')
      }
      return fields
    },
    itemFilter() {
      let item = this.itemProduct.filter(item => {
        let keys = Object.keys(item);
        if (!this.filter) {
          return true;
        }
        if (this.filter){
          return Object.values(item).some((val)=>{
            return String(val).toLowerCase().includes(this.filter.toLowerCase())
          })
        }
        // else if(this.filters.courier_code && !this.filter){
        //   return item.courier_code === this.filters.courier_code
        // }
        // else if (this.filters.courier_code && this.filter){
        //  return item.courier_code === this.filters.courier_code&&Object.values(item).some((val)=>{
        //   return String(val).toLowerCase().includes(this.filter.toLowerCase())
        //  })
        // }
      })
      return item;
    },
    options() {
      let options = {};

      let vals = this.itemProduct.map(item => {
        let result;
        if (options[item.courier_code]) {
          result = false;
        } else {
          result = {
            name: item.courier,
            courier_code: item.courier_code
          }
        }
        options[item.courier_code] = true;
        return result;
      });
      vals = vals.filter((x) => { if (x) return x});
      options = Array.from(new Set(vals));

      return options;
    },
    total() {
      return this.itemFilter.reduce((total, product) => {
        return total + Number(product.price);
      }, 0);
    },
    optionsStatus(){
      return [ 
          {value: false, text: 'ดูทั้งหมด'},
          {value: 'WAIT', text: 'รอเข้าระบบ'},
          {value: 'BOOKING', text: 'รอขนส่งเข้ารับ'},
      ]
    },
  }
};
</script>

<style></style>
 